import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Helmet from 'react-helmet';

import { Container, makeStyles } from '@material-ui/core';

import ScrollToTop from '../../../../common/ScrollToTop';
import EmailCheckList from '../../MiyakoTaxi/common/EmailCheckList';
import URLParams from '../../../../../utils/getParams';
import { changeLanguage } from '../../../../../utils/lang';
import { useLocation } from 'react-router-dom';
import { isTabiCube } from '../common/TabiCube';
import AirportTransferTaxiHeader from '../common/Header';
import { HelmetProvider } from 'react-helmet-async';
import AdobeAnalyticsScript from '../../../Common/AdobeAnalyticsScript';

const useStyles = makeStyles(() => ({
  container: {
    marginTop: 10,
  },
}));

/** メールが届かない場合の案内画面のコンポーネント。 */
const Unreceived: React.FC = () => {
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  const location = useLocation();
  const searchParams = new URLParams(location.search);
  // 言語設定をする
  changeLanguage(searchParams, i18n);
  /** referrerパラメーターの値。 */
  const referrer = searchParams.getStringParam('referrer');
  /** 旅CUBEモードであるか判定した結果。 */
  const tabiCube = isTabiCube(referrer || '');
  /** ページタイトル。 */
  const title = tabiCube ? t('tabicube') : t('title');
  return (
    <div>
      <HelmetProvider>
        <Helmet>
          {/* ページタイトルを設定する。 */}
          <title>{title}</title>
          {/* Adobe Analyticsでタクシー予約画面のアクセス数の集計をする。 */}
          {/* <script type="application/javascript">
            s.pageName=location.origin+&quot;/booking-taxi/unreceived&quot;;
            s.t();
          </script> */}
        </Helmet>
      </HelmetProvider>
      <AdobeAnalyticsScript path="/booking-taxi/unreceived"/>
      {/* 画面遷移時に画面トップへ遷移させるためのコンポーネント。 */}
      <ScrollToTop />
      {/* ヘッダー。 */}
      <AirportTransferTaxiHeader tabiCube={tabiCube} />
      <Container maxWidth="md" className={classes.container}>
        <EmailCheckList/>
      </Container>
    </div>
  )
};

export default Unreceived;
